/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { styled } from '@mui/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view';

export const StyledClusterTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.label}`]: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 400,
    padding: '13px 12px !important',
  },
  [`& .${treeItemClasses.focused}`]: {
    background: 'none !important',
  },
  [`& .${treeItemClasses.selected}`]: {
    background: 'none !important',
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '-18px',
      top: '50%',
      display: 'block',
      width: '18px',
      height: '1px',
      backgroundColor: theme.palette.primary.main,
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '-17px',
      bottom: '50%',
      display: 'block',
      width: '1px',
      height: '9999px',
      backgroundColor: theme.palette.primary.main,
    },
    [`& .${treeItemClasses.label}`]: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
}));
